export enum AuthRoutes {
    Login = 'Login',
    ForgotPassword = 'ForgotPassword',
    ResetPassword = 'ResetPassword',
    CreatePassword = 'CreatePassword',
    PrepareDemo = 'PrepareDemo',
}

export enum SharedRoutes {
    Home = 'Home',
    Users = 'Users',
    UsersCreate = 'UsersCreate',
    UsersEdit = 'UsersEdit',
    Profile = 'Profile',
    AntennaMonitoring = 'AntennaMonitoring',
    LogsHooks = 'LogsHooks',
    LogsExternalApi = 'LogsExternalApi',
    LogsAntennaStats = 'LogsAntennaStats',
    LogsEpcReadings = 'LogsEpcReadings',
    LogsWarehouseNodeEpc = 'LogsWarehouseNodeEpc',
    EanRegistry = 'EanRegistry',
    EanRegistryCreate = 'EanRegistryCreate',
    EanRegistryEdit = 'EanRegistryEdit',
    CashRegisters = 'CashRegisters',
    CashRegistersCreate = 'CashRegistersCreate',
    CashRegistersEdit = 'CashRegistersEdit',
    PackingStations = 'PackingStations',
    PackingStationsCreate = 'PackingStationsCreate',
    PackingStationsEdit = 'PackingStationsEdit',
    PackageContents = 'PackageContents',
}

export enum SuperAdminRoutes {
    Companies = 'Companies',
    CompaniesCreate = 'CompaniesCreate',
    CompaniesEdit = 'CompaniesEdit',
    CompaniesSettings = 'CompaniesSettings',
    Devices = 'AdminDevices',
    DevicesCreate = 'AdminDevicesCreate',
    DevicesEdit = 'AdminDevicesEdit',
    Readers = 'Readers',
    ReadersCreate = 'ReadersCreate',
    ReadersEdit = 'ReadersEdit',
    Printers = 'Printers',
    PrintersCreate = 'PrintersCreate',
    PrintersEdit = 'PrintersEdit',
    FeatureFlags = 'FeatureFlags',
    EanVersions = 'EanVersions',
    EmailLogs = 'EmailLogs',
    AntennaEpcTesting = 'AntennaEpcTesting',
    DummyCashRegister = 'DummyCashRegister',
    CapabilityDefinitions = 'CapabilityDefinitions',
    CapabilityDefinitionsCreate = 'CapabilityDefinitionsCreate',
    CapabilityDefinitionsEdit = 'CapabilityDefinitionsEdit',
}

export enum ErrorRoutes {
    Error403 = 'Error403',
    Error404 = 'Error404',
    Error500 = 'Error500',
}

export enum CompanyAdminRoutes {
    Locations = 'Locations',
    LocationsCreate = 'LocationsCreate',
    LocationsEdit = 'LocationsEdit',
    LocationsHooks = 'LocationsHooks',
    LocationsFloorPlan = 'LocationsFloorPlan',
    WarehouseFloorPlan = 'WarehouseFloorPlan',
    CompanyApiTokens = 'CompanyApiTokens',
    CompanyApiTokensCreate = 'CompanyApiTokensCreate',
    CompanyApiTokensEdit = 'CompanyApiTokensEdit',
    Products = 'Products',
    ProductsCreate = 'ProductsCreate',
    ProductsEdit = 'ProductsEdit',
    ProductsEpc = 'ProductsEpc',
    AntennaStatus = 'AntennaStatus',
    ProductsEanRegistration = 'ProductsEanRegistration',
    ProductsEanRegistration2 = 'ProductsEanRegistration2',
    ProductsBulkMarkingRegistration = 'ProductsBulkMarkingRegistration',
    ProductsStockIn = 'ProductsStockIn',
    ProductsStockOut = 'ProductsStockOut',
    Packages = 'Packages',
    PackageDetail = 'PackageDetail',
    Promotions = 'Promotions',
    PromotionsCreate = 'PromotionsCreate',
    PromotionsEdit = 'PromotionsEdit',
    Operators = 'Operators',
    OperatorsCreate = 'OperatorsCreate',
    OperatorsEdit = 'OperatorsEdit',
    OperatorAccessLogs = 'OperatorAccessLogs',
    Transactions = 'Transactions',
    Receipts = 'Receipts',
    Vouchers = 'Vouchers',
    SalesOverview = 'SalesOverview',
    TruckReport = 'TruckReport',
    TruckReportDetail = 'TruckReportDetail',
    TaggingAttendance = 'TaggingAttendance',
    LiveStore = 'LiveStore',
    LiveStoreView = 'LiveStoreView',
    LiveWarehouse = 'LiveWarehouse',
    LiveWarehouseView = 'LiveWarehouseView',
    WarehouseAnalysis = 'WarehouseAnalysis',
    WarehouseAnalysisView = 'WarehouseAnalysisView',
    StoreAnalysis = 'StoreAnalysis',
    StoreAnalysisView = 'StoreAnalysisView',
    Statistics = 'Statistics',
    Settings = 'Settings',
    TranslationsOverview = 'TranslationsOverview',
    Warehouse = 'Warehouse',
    InventoryRetail = 'InventoryRetail',
    InventoryRetailDetail = 'InventoryRetailDetail',
    InventoryLogistics = 'InventoryLogistics',
    InventoryLogisticsDetail = 'InventoryLogisticsDetail',
    InventoryManufacturing = 'InventoryManufacturing',
    InventoryManufacturingDetail = 'InventoryManufacturingDetail',
    Devices = 'Devices',
    DevicesDetail = 'DevicesDetail',
    DevicesEdit = 'DevicesEdit',
    PaymentConfigurations = 'PaymentConfigurations',
    PaymentConfigurationsCreate = 'PaymentConfigurationsCreate',
    PaymentConfigurationsEdit = 'PaymentConfigurationsEdit',
    ErosConfigurations = 'ErosConfigurations',
    ErosConfigurationsCreate = 'ErosConfigurationsCreate',
    ErosConfigurationsEdit = 'ErosConfigurationsEdit',
    PriceTemplates = 'PriceTemplates',
    PriceTemplatesCreate = 'PriceTemplatesCreate',
    PriceTemplatesEdit = 'PriceTemplatesEdit',
    AiChat = 'AiChat',
    AiChatDetail = 'AiChatDetail',
    Insights = 'Insights',
    RoiCalculator = 'RoiCalculator',
    PisnerRoi = 'PisnerRoi',
    RfidBuilder = 'RfidBuilder',
    PackingStationsMonitor = 'PackingStationsMonitor',
    ProductTypes = 'ProductTypes',
    ProductTypesCreate = 'ProductTypesCreate',
    ProductTypesEdit = 'ProductTypesEdit',
    Workers = 'Workers',
    WorkerDetail = 'WorkerDetail',
    WasteCollectionContainers = 'WasteCollectionContainers',
    WasteCollectionContainersCreate = 'WasteCollectionContainersCreate',
    WasteCollectionContainerDetail = 'WasteCollectionContainerDetail',
    WasteCollectionMap = 'WasteCollectionMap',
    WasteCollectionRuns = 'WasteCollectionRuns',
    WasteCollectionRunDetail = 'WasteCollectionRunDetail',
    WasteCollectionRunPrint = 'WasteCollectionRunPrint',
    WasteCollectionEvents = 'WasteCollectionEvents',
    WasteCollectionVehicles = 'WasteCollectionVehicles',
    WasteCollectionContainerTypes = 'WasteCollectionContainerTypes',
    WasteCollectionContainerTypesCreate = 'WasteCollectionContainerTypesCreate',
    SortingTests = 'SortingTests',
    SortingTestDetail = 'SortingTestDetail',
    SortingTestsSamples = 'SortingTestsSamples',
    SortingTestsSamplesCreate = 'SortingTestsSamplesCreate',
    SortingTestsSamplesEdit = 'SortingTestsSamplesEdit',
    SortingTestsSampleDetail = 'SortingTestsSampleDetail',
    SortingTestsStations = 'SortingTestsStations',
    SortingTestsStationsCreate = 'SortingTestsStationsCreate',
    SortingTestsStationsEdit = 'SortingTestsStationsEdit',
    SortingTestsLine = 'SortingTestsLine',
    LabelDesigns = 'LabelDesigns',
}
